<template>
  <div class="page d-flex">
    <MenuComponent />
    <DeveloprViewComponent />
  </div>
</template>

<script>
import MenuComponent from "@/components/user/layout/MenuComponent.vue";
import DeveloprViewComponent from "@/components/user/viewComponent/developer/DeveloprViewComponent.vue";

export default {
  name: "DeveloperView",
  components: {
    MenuComponent: MenuComponent,
    DeveloprViewComponent
  },
};
</script>
